export default __webpack_public_path__ + "static/media/effra_heavy-webfont.ec39f9c8.woff2";